// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/autoplay"
import { useRef, useState } from "react"
import {
  A11y,
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
} from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

import ReferralPreviewCard from "./ReferralPreviewCard"

const ReferralPreviewCarousel = ({
  items,
}: {
  items: {
    text: string
    image: string
  }[]
}) => {
  const swiperRef = useRef<any>(null)
  const [currentSlide, setCurrentSlide] = useState(0)

  const handleSlideChange = (index: number) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(index)
      setCurrentSlide(index)
    }
  }

  return (
    <div
      className="flex flex-col items-center"
      style={{ width: "min(100%, 400px)" }}
    >
      <div className="w-full gap-2 overflow-hidden bg-white">
        <Swiper
          loop
          modules={[Pagination, Navigation, Scrollbar, A11y, Autoplay]}
          pagination={false}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
          onInit={(swiper: any) => (swiperRef.current = swiper)}
          className="w-full h-full flex-1"
        >
          {items.map((item, index) => (
            <SwiperSlide key={index} className="w-full">
              <ReferralPreviewCard preview={item} inCarousel />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="flex flex-row items-center justify-center mt-3 gap-2 w-fit py-1 px-2 bg-bgXLightGray rounded-full">
        {items.map((_, index) => (
          <button key={index} onClick={() => handleSlideChange(index)}>
            <div
              className={`w-2 h-2 rounded-full transition-colors ${index === currentSlide ? "bg-primary" : "bg-white"}`}
            />
          </button>
        ))}
      </div>
    </div>
  )
}

export default ReferralPreviewCarousel
